// extracted by mini-css-extract-plugin
module.exports = {"scrollContainer":"Timeline_scrollContainer__39yW1","body":"Timeline_body__22013","gridArea":"Timeline_gridArea__3v2jv"};